import * as yup from 'yup'
import { KnowledgeBaseFileSchema } from 'validations/KnowledgeBaseFileSchema'
import { KnowledgeBaseVisibilityType } from 'types/KnowledgeBaseVisibilityType'

const KnowledgeBaseContentFilesSchema = yup.object().shape({
  files: yup.array().of(KnowledgeBaseFileSchema),
  visibility: yup
    .string()
    .oneOf([
      KnowledgeBaseVisibilityType.Author,
      KnowledgeBaseVisibilityType.Company,
      KnowledgeBaseVisibilityType.UsersList
    ], 'knowledgeBase.errors.visibility.incorrect')
    .required('knowledgeBase.errors.visibility.required'),
})

export { KnowledgeBaseContentFilesSchema }
